<template>
  <div class="ss__desktop__menu__prime__explore__wrapper">
    <div class="ss__desktop__menu__prime__explore">
      <div
        v-for="a in item.children"
        :key="a.name"
        :style="a.style"
        class="ss__desktop__menu__prime__explore__content">
        <i :class="['ss__desktop__menu__prime__explore__content__icon', a.icon]"/>
        <span class="ss__desktop__menu__prime__explore__content__name">{{ a.name }}</span>
      </div>
    </div>
    <a :href="item.button.url" class="ss__desktop__menu__prime__explore__link">
      <SsButton2 :style="item.button.style" class="ss__desktop__menu__prime__explore__btn">
        <span>{{ item.button.text }}</span>
      </SsButton2>
    </a>
  </div>
</template>

<script>
import SsButton2 from '../../../SsButton2'
export default {
  name: 'SsDesktopMenuPrimeExplore',

  components: {
    SsButton2
  },

  props: {
    item: Object
  },

  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.ss__desktop__menu__prime__explore__wrapper {
  display: flex;
  justify-content: space-between;

  .ss__desktop__menu__prime__explore {
    width: 268px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 24px;
    row-gap: 16px;
  }
}
.ss__desktop__menu__prime__explore__content {
  display: flex;
  align-items: center;
  width: var(--w-SsDesktopMenuPrimeExploreContent, 122px);
  column-gap: var(--gap-SsDesktopMenuPrimeExploreContent, 4px);
}
.ss__desktop__menu__prime__explore__content__icon {
  font-size: var(--text-SsDesktopMenuPrimeExploreContentIcon, 24px);
  color: var(--color-SsDesktopMenuPrimeExploreContentIcon, var(--B8-t));
}
.ss__desktop__menu__prime__explore__content__name {
  font-size: var(--text-SsDesktopMenuPrimeExploreContentName, 15px);
  color: var(--color-SsDesktopMenuPrimeExploreContentName, var(--B8-t));
}
.ss__desktop__menu__prime__explore__link {
  margin-top: auto;
}
.ss__desktop__menu__prime__explore__btn {
  width: 92px;
  height: 40px;
  color: var(--color-SsDesktopMenuPrimeExploreBtn, #fff);
  background: var(--color-SsDesktopMenuPrimeExploreBtn-bg, var(--prime));
  border-radius: 10px;
  font-size: 17px;
  font-weight: 500;
}
</style>
